import { translate } from '@cashfree-intl/coherent';
import * as Yup from 'yup';

const message = {
  required: `${translate('this_is_a_required_field')}`,
  validHttpsAppLink: `${translate(
    'enter_a_valid_https_app_link_ensuring_it_begins_with_https',
  )}`,
  validHttpsWebsite: `${translate(
    'enter_a_valid_https_website_url_ensuring_it_begins_with_https',
  )}`,
  validWebsite: `${translate('enter_valid_website_url')}`,
  validAppLink: `${translate('enter_valid_app_link')}`,
  maxLimitExceeded: `${translate('maximum_600_characters_exceeded')}`,
};

export const getAddToWhitelistSchema = (
  isWebsite: boolean,
  isTest: boolean,
) => {
  const websiteMessage = isTest
    ? message.validWebsite
    : message.validHttpsWebsite;
  const appMessage = isTest ? message.validAppLink : message.validHttpsAppLink;
  return Yup.object({
    channelValue: Yup.string()
      .matches(
        // eslint-disable-next-line
        isTest
          ? /(?:[a-z\d]+(?:-[a-z\d]+)*\.)+[a-z\d]+(?:-[a-z\d]+)*(?:\/[a-zA-Z0-9_-]*)*(?:\?[a-zA-Z0-9_=&%+.-]*)?(?:#[a-zA-Z0-9_-]*)?$/
          : /^https:\/\/(?:[a-z\d]+(?:-[a-z\d]+)*\.)+[a-z\d]+(?:-[a-z\d]+)*(?:\/[a-zA-Z0-9_-]*)*(?:\?[a-zA-Z0-9_=&%+.-]*)?(?:#[a-zA-Z0-9_-]*)?$/,
        isWebsite ? websiteMessage : appMessage,
      )
      .required(message.required)
      .trim(),
    testCredentials: Yup.string()
      .when('loginAvailable', {
        is: (loginAvailable: boolean) => loginAvailable,
        then: schema => schema.required(message.required),
      })
      .trim(),
  });
};

export const inactiveWebsiteSchema = Yup.object({
  reason: Yup.string()
    .required(message.required)
    .max(600, message.maxLimitExceeded),
});
